export default __webpack_public_path__ + "navigation-examples-custom-location-indicator-1200-64f8f3001dbb2de54542ee864c15fd52.png";